/* eslint-disable react/prop-types */
import { Paper, TableContainer } from "@mui/material";

const CustomTableContainer = ({ children, handleScroll, sx = {} }) => {
  const defaultStyles = {
    maxHeight: "70vh",

    "&::-webkit-scrollbar-thumb": {
      background: "#BFD6F8",
    },
    "&::-webkit-scrollbar": {
      background: "#BFD6F8",
      width: "10px",
    },
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "#BFD6F8",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: "#BFD6F8",
    },
    "&::-webkit-scrollbar-button:single-button": {
      background: "#BFD6F8",
      display: "block",
      height: "12px",
      width: "12px",
    },
    "&::-webkit-scrollbar-button:single-button:vertical:decrement": {
      background:
        'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg>\') center no-repeat',
    },
    "&::-webkit-scrollbar-button:single-button:vertical:increment": {
      background:
        'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>\') center no-repeat',
    },
    "&::-webkit-scrollbar-button:single-button:horizontal:decrement": {
      background:
        'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>\') center no-repeat',
    },
    "&::-webkit-scrollbar-button:single-button:horizontal:increment": {
      background:
        'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>\') center no-repeat',
    },
  };
  const combinedStyles = { ...defaultStyles, ...sx };
  return (
    <TableContainer
      component={Paper}
      onClick={handleScroll}
      className="scroll container"
      sx={combinedStyles}
      onScroll={handleScroll}
    >
      {children}
    </TableContainer>
  );
};

export default CustomTableContainer;
